var version = {
    "name":      "dativery",
    "buildDateCode": "20260209-092038",
    "buildDate": "Mon Feb 09 2026 09:20:38 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260209-092038",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;